var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.66,20.573c-4.218-4.904-6.428-11.241-6.253-17.693L52.643,2.5c0,0,0,0.673,0,1.579v65.887 c-4.244,18.913-31.616,13.978-28.876-5.265c1.529-8.79,10.972-14.198,19.365-11.141c0,0,0-16.084,0-16.084 C24.861,34.295,7.546,48.837,7.728,67.364c1.597,40.179,59.226,40.185,60.825,0c-0.403-1.438-0.178-28.214-0.235-30.472 c7.168,4.46,15.508,6.689,23.954,6.405V26.685C84.464,26.685,78.505,24.609,74.66,20.573z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.3b5a623d541dc08db5091e0cedca0b38.svg";
export { ForwardRef as ReactComponent };